import { render, staticRenderFns } from "./BaseField.vue?vue&type=template&id=02cc8ec5&scoped=true"
import script from "./BaseField.vue?vue&type=script&lang=js"
export * from "./BaseField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02cc8ec5",
  null
  
)

export default component.exports